import React, { useState,useEffect,useRef } from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import { UserOutlined, HomeOutlined, DollarOutlined } from '@ant-design/icons';
import videoSource from '../../src/assets/video/20250312 PAC2025 - KLYSSA JAMIE CHONG (Landscape Highlights).mp4';
import './Home.css';
import award1 from '../../src/assets/image/GoldAchieverV6.JPG';
import award2 from '../../src/assets/image/R069265I-SEP2024.png';
import award3 from '../../src/assets/image/R069265I-JUN2024.png';
import award4 from '../../src/assets/image/R069265I-MAR2025.jpg';
import award9 from '../../src/assets/image/TopProducer.png';
import award10 from '../../src/assets/image/Propnex_Gen_Achiever-53-JAN - FEB2025-R069265I.jpg';
import award11 from '../../src/assets/image/R069265I-APR2024.png';
import award12 from '../../src/assets/image/R069265I-APR2025.jpg';
import award13 from '../../src/assets/image/R069265I-DEC2024.png';
import award14 from '../../src/assets/image/R069265I-FEB2025.jpg';
import award15 from '../../src/assets/image/R069265I-JAN2025.jpg';
import award16 from '../../src/assets/image/R069265I-OCT2024.png';
import award17 from '../../src/assets/image/R069265I-JUL2024.png';
import award18 from '../../src/assets/image/R069265I-MAR2024.png';
import award19 from '../../src/assets/image/R069265I-MAY2024.png';
import award20 from '../../src/assets/image/GoldAchieverV7.JPG';
import award21 from '../../src/assets/image/R069265I-MAY2025.jpg';
// import award22 from '../../src/assets/image/GoldAchieverV7.JPG';
// import award23 from '../../src/assets/image/GoldAchieverV7.JPG';


const Home = () => {
  const [failedEmbeds, setFailedEmbeds] = useState({});


  const instagramReels = [
    {
      url: "https://www.instagram.com/reel/DJHUed3hLRq/?igsh=MW1wZ2JybWJneGJmeA==",
      embedUrl: "https://www.instagram.com/p/DJHUed3hLRq/embed",
      thumbnail: "https://example.com/thumb1.jpg",
      title: "Property Tour Reel"
    },
    {
      url: "https://www.instagram.com/reel/DJRWv4WB8vw/?igsh=MXVudHExM2RvZWdzaQ==",
      embedUrl: "https://www.instagram.com/p/DJRWv4WB8vw/embed",
      thumbnail: "https://example.com/thumb2.jpg",
      title: "Luxury Home Preview"
    },
    {
      url: "https://www.instagram.com/reel/DH6DaiThpe7/?igsh=MTNlbTJvdnZmNnM2bw==",
      embedUrl: "https://www.instagram.com/p/DH6DaiThpe7/embed",
      thumbnail: "https://example.com/thumb3.jpg",
      title: "Neighborhood Guide"
    },
    {
      url: "https://www.instagram.com/reel/DKPYzJLBNRQ/?igsh=MW1lY2E1aGNwbzJwcw==",
      embedUrl: "https://www.instagram.com/p/DKPYzJLBNRQ/embed",
      thumbnail: "https://example.com/thumb4.jpg",
      title: "Client Testimonial"
    },
    { 
    url: "https://www.instagram.com/reel/DMIG9llBj8m/?igsh=ZGJsdGVwd3pja2Fz",
    embedUrl: "https://www.instagram.com/reel/DMIG9llBj8m/embed",
    title: "Reel 1"
  },
  {
    url: "https://www.instagram.com/reel/DLSG1cJhcCj/?igsh=MTJxZ3Q4NHNmaWhhaA==",
    embedUrl: "https://www.instagram.com/reel/DLSG1cJhcCj/embed",
    title: "Reel 2"
  },
  {
    url: "https://www.instagram.com/reel/DIlhZmDBmGl/?igsh=MWxibmVyaGljNHdsYQ==",
    embedUrl: "https://www.instagram.com/reel/DIlhZmDBmGl/embed",
    title: "Reel 3"
  },
  {
    url: "https://www.instagram.com/reel/DF-IK2OyJBL/?igsh=MTlkem14aWtpMzZuaA==",
    embedUrl: "https://www.instagram.com/reel/DF-IK2OyJBL/embed",
    title: "Reel 4"
  },
  {
    url: "https://www.instagram.com/reel/DDbw3K_SMc9/?igsh=MWk4NWloaWZxaXV0aA==",
    embedUrl: "https://www.instagram.com/reel/DDbw3K_SMc9/embed",
    title: "Reel 5"
  }
  ];

const [carouselIndex, setCarouselIndex] = useState(0);
const itemsPerSlide = window.innerWidth >= 1024 ? 4 : window.innerWidth >= 768 ? 2 : 1;
const [scrollIndex, setScrollIndex] = useState(0);
const scrollRef = useRef(null);

const handleScroll = (direction) => {
  const container = scrollRef.current;
  const cardWidth = container.querySelector('.reel-card')?.offsetWidth || 300;
  const gap = 16; // same as CSS gap
  const scrollAmount = cardWidth + gap;

  if (direction === 'left') {
    container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    setScrollIndex(prev => Math.max(prev - 1, 0));
  } else {
    container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    setScrollIndex(prev => prev + 1);
  }
};



  const awards = [
    {
      id: 1,
      image: award1,
      title: "Gold Achiever Award (Dec 2023)",
      description: "Recognized for top sales performance"
    },
    {
      id: 2,
      image: award2,
      title: "Top Producer (Sep 2024)",
      description: "Awarded for September 2024 performance"
    },
    {
      id: 3,
      image: award3,
      title: "Top Producer (Jun 2024)",
      description: "Awarded for June 2024 performance"
    },
    {
      id: 4,
      image: award4,
      title: "Top Producer (Mar 2025)",
      description: "Awarded for March 2025 performance"
    },
    // {
    //   id: 5,
    //   image: award5,
    //   title: "Top Producer (Mar 2025)",
    //   description: "Awarded for March 2025 performance"
    // },
    // {
    //   id: 6,
    //   image: award6,
    //   title: "Top Producer (Mar 2025)",
    //   description: "Awarded for March 2025 performance"
    // },
    // {
    //   id: 7,
    //   image: award7,
    //   title: "Top Producer (Mar 2025)",
    //   description: "Awarded for March 2025 performance"
    // },
    // {
    //   id: 8,
    //   image: award8,
    //   title: "Top Producer (Mar 2025)",
    //   description: "Awarded for March 2025 performance"
    // },
    {
      id: 9,
      image: award9,
      title: "Top Producer Overall",
      description: "Awarded for Overall Top Producer"
    },
    {
      id: 10,
      image: award10,
      title: "Propnex Gen Achiever",
      description: "Top Achiever Under 35"
    },
    {
      id: 11,
      image: award11,
      title: "Top Producer (Apr 2024)",
      description: "Awarded for April 2024 performance"
    },
    {
      id: 12,
      image: award12,
      title: "Top Producer (April 2025)",
      description: "Awarded for April 2025 performance"
    },
    {
      id: 13,
      image: award13,
      title: "Top Producer (Dec 2024)",
      description: "Awarded for December 2024 performance"
    },
    {
      id: 14,
      image: award14,
      title: "Top Producer (Feb 2025)",
      description: "Awarded for February 2025 performance"
    },
    {
      id: 15,
      image: award15,
      title: "Top Producer (Jan 2025)",
      description: "Awarded for January 2025 performance"
    },
    {
      id: 16,
      image: award16,
      title: "Top Producer (Oct 2024)",
      description: "Awarded for October 2024 performance"
    },
    {
      id: 17,
      image: award17,
      title: "Top Producer (Jul 2024)",
      description: "Awarded for July 2024 performance"
    },
    {
      id: 18,
      image: award18,
      title: "Top Producer (Mar 2024)",
      description: "Awarded for March 2024 performance"
    },
    {
      id: 19,
      image: award19,
      title: "Top Producer (May 2024)",
      description: "Awarded for May 2024 performance"
    },
    // {
    //   id: 20,
    //   image: award20,
    //   title: "Gold Achiever (Feb 2025)",
    //   description: "Recognized for top sales performance"
    // },
    {
      id: 21,
      image: award21,
      title: "Top Producer (May 2025)",
      description: "Awarded for May 2025 performance"
    },

  ];

  const handleEmbedError = (index) => {
    setFailedEmbeds(prev => ({ ...prev, [index]: true }));
  };

  return (
    <div className="homepage">
      {/* Hero Video Section with Stats Cards */}
      <section className="hero-section">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="hero-video"
        >
          <source src={videoSource} type="video/mp4" />
        </video>
        
        {/* Stats Cards Overlay */}
        <div className="stats-overlay">
          <Row gutter={[24, 24]} justify="center">
            <Col xs={24} sm={12} md={6}>
              <Card className="stat-card">
                <Statistic className = "carved-text"
                  title="Total Views"
                  value="5,102,254"
                  prefix={<UserOutlined />}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card className="stat-card">
                <Statistic className = "carved-text"
                  title="Videos Produced"
                  value="100+"
                  prefix={<HomeOutlined />}
                />
              </Card>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Card className="stat-card">
                <Statistic className = "carved-text"
                  title="PropertyGuru Rating"
                  value="5/5"
                  prefix={<DollarOutlined />}
                />
              </Card>
            </Col>
          </Row>
        </div>
      </section>

           {/* Awards Section - Conveyor Belt Style */}
      <section className="awards-section">
        <h2 className="section-title">Our Awards & Recognitions</h2>
        <div className="awards-conveyor-container">
          <div className="awards-track">
            {awards.map((award) => (
              <div key={award.id} className="award-item">
                <Card
                  hoverable
                  className="awards-card"
                  cover={
                    <img 
                      alt={award.title} 
                      src={award.image} 
                      style={{ height: '200px', objectFit: 'contain', padding: '10px' }}
                    />
                  }
                >
                  <Card.Meta
                    title={award.title}
                    description={award.description}
                  />
                </Card>
              </div>
            ))}
            {/* Duplicate items for infinite loop effect */}
            {awards.map((award) => (
              <div key={`duplicate-${award.id}`} className="award-item">
                <Card
                  hoverable
                  className="awards-card"
                  cover={
                    <img 
                      alt={award.title} 
                      src={award.image} 
                      style={{ height: '200px', objectFit: 'contain', padding: '10px' }}
                    />
                  }
                >
                  <Card.Meta
                    title={award.title}
                    description={award.description}
                  />
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram Reels Section */}
      <section className="reels-section">
        <h2 className="section-title">Featured Instagram Reels</h2>
<div className="carousel-container">
  <button className="carousel-btn left" onClick={() => handleScroll('left')}>&#8249;</button>

  <div className="carousel-track" ref={scrollRef}>
    {instagramReels.map((reel, index) => (
      <Card key={index} className="reel-card" hoverable>
        <div className="reel-embed-container">
          <iframe
            src={`${reel.embedUrl}/captioned`}
            title={reel.title}
            frameBorder="0"
            scrolling="no"
            allowFullScreen
          />
        </div>
        <a
          href={reel.url}
          target="_blank"
          rel="noopener noreferrer"
          className="reel-link"
        >
          View on Instagram
        </a>
      </Card>
    ))}
  </div>

  <button className="carousel-btn right" onClick={() => handleScroll('right')}>&#8250;</button>
</div>


      </section>
    </div>
  );
};

export default Home;